
<div class="grid-container full-height full v-pad">
  <div class="user-form-max-width">
    <h2>Return Chiefs Order</h2>
    <div class="grid-x grid-margin-x">
      @for (buttonProps of buttonArray; track buttonProps) {
        <div class="cell small-12 form-button-group">
          Return to:
          <button class="button hollow" (click)="returnCO($event)" id="{{buttonProps.id}}" >{{buttonProps.name}}</button>
        </div>
      }
    </div>
  </div>
  <button class="back-link vertical-middle" (click)="goToReview()" type="button">
    <span aria-hidden="true" class="back-link-span">
      <svg-icon icon="icon-chevron-left" class="white" aria-hidden="true"></svg-icon>
    </span>
    <span>Previous</span>
  </button>
</div>